export default __webpack_public_path__ + "static/media/logo.fc3ff5f1.jpg";